<main class="zoom-section">
<!-- <div id="meetingSDKElement" style="display: none;">
</div>

<button (click)="getSignature()">Join Meeting</button> -->
</main>